export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Krys.405d6a63.jpg";